import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web

import adminReducer from './features/admin';
import adminWorkDaysReducer from './features/adminWorkDays';
import bankAccountsReducer from './features/bankAccounts';
import bankingFeesReducer from './features/bankingFee';
import clientsReducer from './features/clients';
import expensesReducer from './features/expenses';
import filesReducer from './features/files';
import importExportMoneyRerducer from './features/importExportMoney';
import insuranceReducer from './features/insurance';
import insuranceIncomeReducer from './features/insuranceIncome';
import invoicesReducer from './features/invoices';
import monthReport from './features/month-report';
import sickLeaveReducer from './features/sickLeave';
import usersReducer from './features/users';

const persistConfig = {
  key: "root",
  storage,
};

const reducers = combineReducers({
  users: usersReducer,
  expenses: expensesReducer,
  clients: clientsReducer,
  invoices: invoicesReducer,
  monthReport: monthReport,
  insurances: insuranceReducer,
  insuranceIncome: insuranceIncomeReducer,
  importExportMoney: importExportMoneyRerducer,
  admin: adminReducer,
  files: filesReducer,
  bankAccounts: bankAccountsReducer,
  sickLeave: sickLeaveReducer,
  adminWorkDays: adminWorkDaysReducer,
  bankingFees: bankingFeesReducer
});


// Handle logout in rootReducer
const rootReducer = (state, action) => {
  if (action.type === 'users/logoutUser') {
    // Reset users slice to its initial state (if your usersReducer handles undefined)
    state = {
      ...state,
      users: undefined,
    };
    localStorage.removeItem('token');
  }
  return reducers(state, action);
}

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
});

const persistor = persistStore(store);

export { persistor, store };
